import React from "react";

const SERVICES = [
    {
        num: "01",
        title: "Managed IT Support",
        desc: "Proactive maintenance, rapid troubleshooting, and 24/7 monitoring to keep your systems running at peak performance.",
    },
    {
        num: "02",
        title: "Cloud Computing",
        desc: "Secure migration, hybrid cloud integration, and scalable hosting solutions tailored to your business requirements.",
    },
    {
        num: "03",
        title: "Network Infrastructure",
        desc: "Expert design, deployment, and optimization for reliable connectivity across all your business operations.",
    },
    {
        num: "04",
        title: "Backup & Recovery",
        desc: "Local and cloud backup solutions ensuring business continuity and rapid disaster recovery when you need it most.",
    },
];

const Services: React.FC = () => (
    <section className="services" id="services">
        <div className="section-number">02</div>
        <div className="container">
            <div className="services-header">
                <span className="section-eyebrow">What We Do</span>
                <h2 className="section-title">Core Services</h2>
            </div>
            <div className="services-grid">
                {SERVICES.map(s => (
                    <div className="service-card" key={s.num}>
                        <div className="service-num">{s.num}</div>
                        <div className="service-line" />
                        <h3>{s.title}</h3>
                        <p>{s.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Services;
